<template>
	<div class="navbar-dark bg-dark p-0 px-1 p-sm-1 sticky-top heade-top"  id="header">
		
		<div class="row py-2 no-gutters" >
			<div class="col-2">
				<router-link class="navbar-brand pb-0 d-flex align-items-center" to="/clientes/">
					<img class="ml-2 ml-lg-4 d-none d-md-block" @click="enviarInicio" src="@/assets/img-priv/logoDifarmer.png" />
					<img class="ml-1 d-inline d-md-none" @click="enviarInicio" src="@/assets/img-priv/LogoDifarmercolapsado.png" />
				</router-link>
			</div>
			<!-- <div class="col-7  col-md-8 col-lg-6" v-click-outside="onClickOutside"> -->
			<div class="col-5  col-md-6 col-lg-4" v-click-outside="onClickOutside">
				<input
					@keyup.enter.prevent="buscar"
					@focus="listaVisible = true"
					@input="filtrar"
					@keydown.down="down"
					@keydown.up="up"
					aria-describedby="basic-addon1"
					aria-label="Search"
					class="form-control form-control-sm border-left-0"
					id="buscador"
					ref="buscador"
					placeholder="¿Qué producto buscas?"
					type="search"
					autocomplete="off"
					v-model="textoBuscar"
					:disabled="loading"
					data-toggle="tooltip"
					:title="textoBuscar.length<3?'Debe ingresar al menos 3 caracteres.':''"
				/>
				<div v-if="items && listaVisible && textoBuscar.length > 0 && !loading" class="divContenedor">
					<div class="divAutocomplete" >
						<ul class="ulAutocomplete">
							<li :key="index" 
								:class="indexSeleccionado == index? 'listaBusqueda':''"
								v-for="(item, index) in listaFiltro" 
								@click="clickitem(item.codArticulo)">{{ item.descripcion }}</li>
						</ul>
					</div>
				</div>
			</div>			
			<div class="col-2">
					<pm-button-excel 	class="w-excel"
										:rutaCargado="rutaCargado" 
										@togleMenu=togleMenu></pm-button-excel>
			</div>
			<div class="col-3 col-md-2 col-lg-4 d-flex justify-content-end align-items-center">
				<!-- <Notificaciones
					:notificaciones="notificaciones"
					:notificacionesPendientes="notificacionesPendientes"
					@actualizarNotificaciones="actualizarNotificaciones"
					class="d-inline"
				></Notificaciones> -->
				<!-- Boton carrito de compras -->
				<a class="form-control-sm  btn mr-2"
						@click="carritoCompras">
					<i 	:class="{animacion : animarCarrito}"
						class="icon-grupo-4307 icon-carrito">
						<span class="badge badge-pill badge-carrito">{{totalCarrito}}</span>
					</i>
				</a>

				<OpcionesUsuario class="d-inline" id="opciones-mobile"></OpcionesUsuario>
			</div>
		</div>		
	</div>
</template>

<script>
	//import Notificaciones from "@/components/clientes/Notificaciones"
	import { mapMutations, mapState } from 'vuex'
	import OpcionesUsuario from "@/components/clientes/OpcionesUsuario"
	import vClickOutside from 'v-click-outside'
	import PmButtonExcel from "@/components/clientes/ButtonExcel"

	export default {
		name: "navHeader",
		props: [
			"notificaciones"
			,"notificacionesPendientes"
			,"items"
			,"totalCarrito"
			,"animarCarrito"],
		components: {
			//Notificaciones,
			OpcionesUsuario,
			PmButtonExcel
		},
		directives: {
			clickOutside: vClickOutside.directive
		},
		data() {
			return {
				textoBuscar: "",
				listaVisible: false,
				listaFiltro: [],
				indexSeleccionado:-1,
				rutaCargado: 'carrito',
				codArticuloSeleccionado: 0
			}
		},
		computed:{
			...mapState(['loading']),
		},
		methods: {
			togleMenu(opcion){
				this.$emit('togleMenu', opcion);
			},
			onClickOutside(){
				this.listaVisible = false
			},
			down(){
				if(this.loading){
					return
				}
				if(this.indexSeleccionado < this.listaFiltro.length-1){
					this.indexSeleccionado ++
					this.textoBuscar = this.listaFiltro[this.indexSeleccionado].descripcion
					this.codArticuloSeleccionado = this.listaFiltro[this.indexSeleccionado].codArticulo
				}
				else{
					this.indexSeleccionado = 0
					this.textoBuscar = this.listaFiltro[this.indexSeleccionado].descripcion
					this.codArticuloSeleccionado = this.listaFiltro[this.indexSeleccionado].codArticulo
				}
			},
			up(){
				if(this.loading){
					return
				}
				if(this.indexSeleccionado > 1){
					this.indexSeleccionado --
					this.textoBuscar = this.listaFiltro[this.indexSeleccionado].descripcion
					this.codArticuloSeleccionado = this.listaFiltro[this.indexSeleccionado].codArticulo
				}
				else{
					this.indexSeleccionado = 0
					this.textoBuscar = this.listaFiltro[this.indexSeleccionado].descripcion
					this.codArticuloSeleccionado = this.listaFiltro[this.indexSeleccionado].codArticulo
				}
			},
			carritoCompras(){
				this.indexSeleccionado=-1
				this.$emit("carritoCompras")
			},
			clickitem(item){
				this.codArticuloSeleccionado = item
				this.textoBuscar = /*item.descripcion*/ item.toString() /*Se modifica la asignacion del this.textoBuscar para que mande el codArticulo en ves de la descripcion*/
				this.buscar()
				//this.indexSeleccionado=-1
			},
			filtrar (){
				this.listaFiltro = this.items.filter( 
					item => item.descripcion.toLowerCase().startsWith(this.textoBuscar.toLowerCase()))
			},
			enviarInicio(){
				//console.log('tag', 'sdasdasasdadadas inicio')
				this.indexSeleccionado=-1
				this.$emit("enviarInicio")
			},
			...mapMutations(['setItemSeleccionadoBuscador']),
			buscar() {
				if(this.loading || this.textoBuscar.toString().trim().length < 3){
					this.$bvToast.toast(`Debe de ingresar al menos 3 caracteres.`, {
                        autoHideDelay: 2000,
                        appendToast: false,
                        variant: "info",
                    })
					return
				}
				if (this.codArticuloSeleccionado > 0) {
					this.textoBuscar = this.codArticuloSeleccionado.toString()
					this.setItemSeleccionadoBuscador(true)
				}else{
					this.setItemSeleccionadoBuscador(false)
				}
				this.$emit("buscar", { buscar: this.textoBuscar, pagina: 1, busquedaAvanzada: false })
				this.textoBuscar = ""
				this.codArticuloSeleccionado = 0
				this.indexSeleccionado=-1
			},
			actualizarNotificaciones(notificaciones) {				
				this.$emit("actualizarNotificaciones", notificaciones)
			},
		},	
		watch:{
			listaVisible(newValue){
				if(!newValue){
					this.indexSeleccionado = -1
				}
			},
			textoBuscar(newValue){
				if(newValue.length == 0){
					this.indexSeleccionado = -1
				}
			},
			loading(newValue){
				if(!newValue){
					this.$nextTick(()=>{
						this.$refs.buscador.focus()
					})
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>	
	.w-excel{
            width: 150px;
        }
	.listaBusqueda{
		background-color: var(--bg-menu-blue) !important;
		color: white;
	}
	.animacion {
		animation-name: carrito;
		animation-duration: 2s;
	}

	@keyframes carrito {
		0% {
			color: yellow;
		}
		50% {
			font-size: 1.5em;
		}
		100% {
			font-size: 1em;
			color: white;
		}
	}

	.heade-top{
		position: fixed; 
		top: 0; 
		width:100%;
	}

	.icon-carrito {
		position: relative;
		float: left;
		font-size: 25px;
		color: white;
		top: 0;
		z-index: 1; 
	}

	.badge-carrito {
		top: -0.4rem;
		right: -0.5rem;
		z-index: -1;
		position: absolute;
		font-size:12px;
		background-color: var(--bg-yellow);
		color: var(--bg-menu-blue);
		font-style: normal!important
	}
	.divContenedor
    {
        position: relative;
        z-index: 10;
    }

    .divAutocomplete
    {
        position: absolute;
        width: 100%;
    }

	.ulAutocomplete
    {
        background-color: rgb(240, 244, 255);
        padding-inline-start: 0px!important;
        border: solid 1px rgba(202, 202, 202, 0.781);
        
    }
    .ulAutocomplete li
    {
        list-style: none;
        padding: 3px 20px;
        border-bottom: solid 1px rgba(202, 202, 202, 0.781);
        cursor: pointer;
        background-color: rgb(240, 244, 255);
        word-wrap:break-word;
    }

	.bg-dark {
		background-color: var(--bg-menu-black) !important;
	}

	.navbar-brand img {
		/* width: 130px; */
		height: 24px;
		margin-bottom: 0.2rem;
	}

	#buscador::placeholder {
		font-size: 14px;
		font-weight: normal;
	}

	.btnMovilSearch{
		background: white;
	}
	.btnMovilSearch::placeholder {
		border: none;
		background-color: transparent;
		color: #a0a1a2;
		font-weight: 500;
		height: 50px;
	}

	.btnMovilSearch:focus {
		outline: none;
		border: none;
		box-shadow: none;
	}

	.input-group-append,
	.input-group-append .input-group-text {
		background-color: transparent;
		border: none;
	}

	@media (max-width: 767px) {
		.w-excel{
            width: 60px;
        }
	}

	@media (max-width: 576px) {
		.navbar-brand img {
			/* height: 29px;
			width: 31px; */

			margin-bottom: 0rem;
		}
		.icon-mobile{
			width: 10px;
		}
		.w-excel{
            width: 60px;
        }
	}
</style>
